import { BCMSRecord, BCMSStateManagerCRUD, StateManager, useBCMSContext, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import { PrimaryButton, SecondaryButton } from 'components/ui';
import Classes from "model";
import React from 'react';
import "./styles.css";
import "./mobile.css";


/**
 * @function ImportParticipantsCSVFileWidget
 * @return {React.Component}
 * @exported true
 * @description The widget that shows csv file imports
 */

export default function ImportParticipantsCSVFileWidget(props) {
  const navigate = useRoute();
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    onSelectTemplate: value => {
      BCMSStateManagerCRUD.init(state)
        .update(["data", "selectedTemplate"], value)
        .submit(setState);
    },
    onChooseFile: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "isFileChosen"], true)
        .submit(setState);
    },
    onImportFile: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "isFileChosen"], false)
        .update(["ui", "isFileUploaded"], true)
        .update(["ui", "showFileUploadedBanner"], true)
        .update(["data", "selectedTemplate"], "select")
        .submit(setState);
      window.scrollTo(0, 0);
    },
    onCloseFileUploadedBanner: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "showFileUploadedBanner"], false)
        .submit(setState);

    },
    onViewParticipants: () => {
      navigate("/achParticipants")
    }
  });

  return (
    <StateManager state={{ data, ui }} controller={controller}>
      <WidgetContent />
    </StateManager>
  );
}

export const getDefaultData = () => ({
  // empty for now.
});
export const getDefaultUI = () => ({
  //showAddTemplateFormView: false
});

function WidgetContent(props) {
  const { data, ui, onSelectTemplate, onChooseFile, onImportFile, onCloseFileUploadedBanner, onViewParticipants } = useStateManager();

  const selectedTemplate = data.selectedTemplate;
  const templateOptions = data.importTemplates.reduce((acc, item) => {

    return [...acc, <CustomSelectItem key={item.id} dataPoint={ `Template_Option_${ item.id }` } value={item.id}>{item.templateName}</CustomSelectItem>]
  }
    , [<CustomSelectItem dataPoint={ `Template_Option_Prompt` } key="select" value="select">-- Select a Template --</CustomSelectItem>])

  return (
    <WidgetContainer className="import-participants-csv-file-widget">
      {ui.showFileUploadedBanner && <InfoBanner text="One or more files were imported successfully." onClick={onCloseFileUploadedBanner} />}
      <WidgetView dataPoint="Import_Participants_From_A_CSV_File_Label" text="Import Participants From A CSV File">
        {ui.isFileUploaded &&
          <textarea className="file-uploading-textarea" readOnly defaultValue={
            `* Processing file "${data.fileName}"... \n* 5 participant(s) were added. \n* No participants were updated. \n* One or more files were imported successfully.`
          }>
          </textarea>
        }
        <FormContainer>
          <FormRowView text="* Participant Import Template" className="template-select">
            <CustomSelect dataPoint={ `Participant_Import_Template_Select` } active={ ui.participantImportTemplateSelect.isActive } value={selectedTemplate} onChange={onSelectTemplate} >
              {templateOptions}
            </CustomSelect>
          </FormRowView>
          <p>Maximum file size: 500 KB</p>
          <FormButtonRow>
            <PrimaryButton dataPoint={ `Import_Participants_From_A_CSV_File_View_Participants_Button` } text="View Participants" onClick={onViewParticipants} />
            <PrimaryButton dataPoint={ `Import_Participants_From_A_CSV_File_Import_Button` } text="Import" className={ui.isFileChosen ? "" : "disabled-button"} onClick={onImportFile} />
            <div className="flex-container flex-horizontal align-center upload-file-button-container">
              <SecondaryButton dataPoint={ `Import_Participants_From_A_CSV_File_Choose_File_Button` } text="Choose File" className="flex-width" onClick={onChooseFile} />
              {ui.isFileChosen ? <p>{data.fileName}</p> : <p>No file chosen</p>}
            </div>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  );
}